export type AppSettingKey = (typeof APP_SETTING_KEYS)[number]
export const APP_SETTING_KEYS = ['variant', 'partner_id', 'integration_id', 'show_ad_label'] as const

